(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1487);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ BlurImg; },
/* harmony export */   "f": function() { return /* binding */ BlurImgList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(964);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: auto;\n  top: 0;\n  left: 0;\n  filter: blur(min(5vw, 20px));\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  height: auto;\n  filter: blur(min(5vw, 20px));\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  line-height: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var BlurredImg = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-a7330d7d-0"
})(_templateObject());
function BlurImg(param) {
    var srcJpg = param.srcJpg, srcWebp = param.srcWebp, alt = param.alt, imgBlur = param.imgBlur, aspectRatio = param.aspectRatio;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        style: {
            position: "relative",
            lineHeight: 0,
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlurredImg, {
                src: imgBlur,
                style: {
                    aspectRatio: aspectRatio
                },
                alt: "",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                        srcSet: srcWebp,
                        type: "image/webp"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                        srcSet: srcJpg,
                        type: "image/jpeg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        src: srcJpg,
                        alt: alt,
                        style: {
                            position: "absolute",
                            left: 0,
                            top: 0
                        }
                    })
                ]
            })
        ]
    });
}
var StyledBlurListImg = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-a7330d7d-1"
})(_templateObject1());
var BlurredImgList = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-a7330d7d-2"
})(_templateObject2());
var BlurredImgDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a7330d7d-3"
})(_templateObject3());
function BlurImgList(param) {
    var srcJpg = param.srcJpg, srcWebp = param.srcWebp, alt = param.alt, imgBlur = param.imgBlur, aspectRatio = param.aspectRatio, width = param.width, isFirst = param.isFirst;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BlurredImgDiv, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlurredImgList, {
                src: imgBlur,
                style: {
                    width: width,
                    aspectRatio: aspectRatio
                },
                alt: "",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                        srcSet: srcWebp,
                        type: "image/webp"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                        srcSet: srcJpg,
                        type: "image/jpeg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBlurListImg, {
                        src: srcJpg,
                        alt: alt,
                        loading: isFirst ? "eager" : "lazy"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 7573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getBlogJsonLd; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6701);
/* harmony import */ var _src_getUrls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3916);
/* harmony import */ var _getBlogPostingJsonLd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5383);
/* harmony import */ var _values__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8266);




function getBlogJsonLd(param) {
    var locale = param.locale, blogPosts = param.blogPosts, nestedProperties = param.nestedProperties;
    var base = {
        "@type": "Blog",
        "@id": (0,_src_getUrls__WEBPACK_IMPORTED_MODULE_0__/* .getBlogUrl */ .Z)({
            locale: locale
        }),
        name: _values__WEBPACK_IMPORTED_MODULE_1__/* .blogTitle */ .MH,
        headline: _values__WEBPACK_IMPORTED_MODULE_1__/* .blogTitle */ .MH,
        description: locale === "fr" ? _values__WEBPACK_IMPORTED_MODULE_1__/* .blogDescriptionFr */ .Hz : _values__WEBPACK_IMPORTED_MODULE_1__/* .blogDescription */ .tJ
    };
    if (!nestedProperties) {
        return base;
    }
    var nested = {
        blogPost: blogPosts.map(function(post) {
            return (0,_getBlogPostingJsonLd__WEBPACK_IMPORTED_MODULE_2__/* .getBlogPostingJsonLd */ .C)({
                post: post,
                locale: locale,
                slug: post._sys.filename,
                nestedProperties: false
            });
        })
    };
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, base, nestedProperties ? nested : {});
}


/***/ }),

/***/ 5383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ getBlogPostingJsonLd; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(6701);
// EXTERNAL MODULE: ./src/getUrls.ts
var getUrls = __webpack_require__(3916);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(9384);
// EXTERNAL MODULE: ./components/layout/head/values.ts
var values = __webpack_require__(8266);
;// CONCATENATED MODULE: ./components/layout/head/getAuthorJsonLd.ts

function getAuthorJsonLd(param) {
    var locale = param.locale;
    return {
        "@type": "Person",
        name: values/* blogAuthorName */.yt,
        url: "https://kewindousse.ch"
    };
}

// EXTERNAL MODULE: ./components/layout/head/getBlogJsonLd.ts
var getBlogJsonLd = __webpack_require__(7573);
;// CONCATENATED MODULE: ./components/layout/head/getBlogPostingJsonLd.ts





function getBlogPostingJsonLd(param) {
    var locale = param.locale, post = param.post, slug = param.slug, nestedProperties = param.nestedProperties;
    var ref = (0,utils/* getImageSrc */.Q4)(post.image), ogUrl = ref.og;
    var base = {
        "@type": "BlogPosting",
        "@id": (0,getUrls/* getBlogPostingUrl */.G)({
            locale: locale,
            slug: slug
        }),
        name: post.title,
        headline: post.title,
        description: post.description,
        datePublished: post.date,
        image: (0,utils/* getImageFullUrl */.ZS)(ogUrl),
        author: getAuthorJsonLd({
            locale: locale
        })
    };
    if (!nestedProperties) {
        return base;
    }
    var nested = {
        isPartOf: (0,getBlogJsonLd/* getBlogJsonLd */.v)({
            nestedProperties: false,
            locale: locale
        })
    };
    return (0,_object_spread/* default */.Z)({}, base, nestedProperties ? nested : {});
}


/***/ }),

/***/ 1487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ IndexPage; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2692);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(964);
// EXTERNAL MODULE: ./node_modules/tinacms/dist/react.mjs
var react = __webpack_require__(6945);
// EXTERNAL MODULE: ./node_modules/tinacms/dist/rich-text/index.mjs
var rich_text = __webpack_require__(4626);
// EXTERNAL MODULE: ./components/Box.tsx
var Box = __webpack_require__(4285);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/translations.tsx + 2 modules
var translations = __webpack_require__(171);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(9384);
// EXTERNAL MODULE: ./components/BlurImg.tsx
var BlurImg = __webpack_require__(8972);
;// CONCATENATED MODULE: ./components/PostPreview.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-columns: min(calc(100% - 450px), 40%) auto;\n  max-width: 100%;\n  width: 100%;\n  line-height: 0;\n\n  &.noImage {\n    grid-template-columns: 100%;\n  }\n\n  & .media {\n    line-height: 0;\n  }\n\n  & .media .cropper {\n    height: 290px;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n  }\n\n  & .media .cropped {\n    margin: 0 -300px;\n  }\n\n  & .media img {\n    max-height: 290px;\n  }\n\n  & .content {\n    padding: 0 min(calc(var(--panel-padding) - 10px), 5%) 0\n      min(var(--panel-padding), 5%);\n    line-height: var(--line-height);\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n    justify-content: center;\n    max-height: 290px;\n  }\n\n  &.noImage .content {\n    padding: var(--panel-padding);\n  }\n\n  @media screen and (max-width: 650px) {\n    & {\n      grid-auto-flow: row;\n      grid-template-columns: 1fr;\n    }\n\n    & .content {\n      padding: var(--panel-padding);\n      max-height: unset;\n    }\n\n    & .media .cropper {\n      overflow: auto;\n      height: auto;\n    }\n\n    & .media .cropped {\n      margin: 0 0;\n    }\n\n    & .media img {\n      max-width: 100%;\n      max-height: unset;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var BoxPreview = (0,styled_components_browser_esm/* default */.ZP)(Box/* BoxSection */.js).withConfig({
    componentId: "sc-9c57b96-0"
})(_templateObject());
function PostPreview(param) {
    var post = param.post, isFirst = param.isFirst;
    var locale = (0,router.useRouter)().locale;
    var t = (0,translations/* useT */.N)();
    var title = post.title, description = post.description, date = post.date, body = post.body, image = post.image, blur = post.blur;
    var filename = post._sys.filename;
    var dateDisplay = (0,utils/* displayDate */.Po)(date, locale);
    var readtimeDisplay = (0,utils/* displayReadTime */.mS)(body, t);
    var hasImage = !!image;
    var ref = hasImage ? (0,utils/* getImageSrc */.Q4)(image) : {
        list: null,
        list_webp: null
    }, listUrl = ref.list, listWebpUrl = ref.list_webp;
    var blurData;
    if (hasImage) {
        blurData = blur === null || blur === void 0 ? void 0 : blur.blur;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxPreview, {
        className: !hasImage ? "noImage" : "",
        children: [
            hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/post/".concat(filename),
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "media",
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cropper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cropped",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImg/* BlurImgList */.f, {
                                srcJpg: listUrl,
                                srcWebp: listWebpUrl,
                                alt: title,
                                imgBlur: blurData,
                                aspectRatio: "650 / 368",
                                width: 650,
                                isFirst: isFirst
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        style: {
                            marginTop: 0,
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/post/".concat(filename),
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginTop: 0,
                            marginBottom: "10px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                            children: [
                                dateDisplay,
                                " \xb7 ",
                                readtimeDisplay
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            margin: 0
                        },
                        children: description
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/layout/Layout.tsx + 3 modules
var Layout = __webpack_require__(7487);
// EXTERNAL MODULE: ./components/layout/head/getBlogJsonLd.ts
var getBlogJsonLd = __webpack_require__(7573);
// EXTERNAL MODULE: ./src/getTranslatedPosts.ts
var getTranslatedPosts = __webpack_require__(9378);
;// CONCATENATED MODULE: ./pages/index.tsx

function pages_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











/* eslint-enable prettier/prettier */ var StyledH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-dc18022e-0"
})(pages_templateObject());
var __N_SSG = true;
function IndexPage(props) {
    var ref;
    // Pass our data through the "useTina" hook to make it editable
    var data = (0,react/* useTina */.UL)({
        query: props.query,
        variables: {},
        data: props.data
    }).data;
    var locale = (0,router.useRouter)().locale;
    var page = data.page.body;
    var enEdges = data.postConnection.edges;
    var frEdges = (ref = data.i18n_frConnection) === null || ref === void 0 ? void 0 : ref.edges;
    var translatedPosts = (0,getTranslatedPosts/* getTranslatedPosts */.I)(enEdges, frEdges, locale);
    var sortedPosts = (0,utils/* getSortedListablePosts */.of)(translatedPosts);
    var jsonLd = (0,getBlogJsonLd/* getBlogJsonLd */.v)({
        locale: locale,
        blogPosts: sortedPosts,
        nestedProperties: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
        title: "Protectator",
        jsonLd: jsonLd,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* BoxSection */.js, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rich_text/* TinaMarkdown */.t, {
                        content: page
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH2, {
                    children: "Posts"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: sortedPosts.map(function(post, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostPreview, {
                        post: post,
                        isFirst: i === 0
                    }, post.id);
                })
            })
        ]
    });
}


/***/ }),

/***/ 9378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getTranslatedPosts; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6701);

function getTranslatedPosts(edges, frEdges, locale) {
    var translatedPosts = edges.map(function(e) {
        return e.node;
    });
    if (locale === "fr") {
        // Get data, index it by filename
        var frPosts = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = frEdges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value.node;
                frPosts[node._sys.filename] = node;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Replace data
        translatedPosts = [];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = edges[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var post = _step1.value;
                var correspondingTranslation = frPosts[post.node._sys.filename];
                var frNode = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, post.node, correspondingTranslation);
                translatedPosts.push(frNode);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return translatedPosts;
}


/***/ }),

/***/ 3916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getBlogPostingUrl; },
/* harmony export */   "Z": function() { return /* binding */ getBlogUrl; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9384);

var getOriginWithLocale = function(locale) {
    return "".concat(_utils__WEBPACK_IMPORTED_MODULE_0__/* .ORIGIN */ .jQ).concat(locale === "fr" ? "/fr" : "");
};
var getBlogUrl = function(param) {
    var locale = param.locale;
    return getOriginWithLocale(locale);
};
var getBlogPostingUrl = function(param) {
    var locale = param.locale, slug = param.slug;
    return "".concat(getOriginWithLocale(locale), "/post/").concat(slug);
};


/***/ }),

/***/ 6945:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UL": function() { return /* binding */ useTina; }
/* harmony export */ });
/* unused harmony exports addMetadata, hashFromQuery, tinaField, useEditState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useTina(props) {
  const stringifiedQuery = JSON.stringify({
    query: props.query,
    variables: props.variables
  });
  const id = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(
    () => hashFromQuery(stringifiedQuery),
    [stringifiedQuery]
  );
  const [data, setData] = react__WEBPACK_IMPORTED_MODULE_0__.useState(props.data);
  const [isClient, setIsClient] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
  const [quickEditEnabled, setQuickEditEnabled] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
  const [isInTinaIframe, setIsInTinaIframe] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    setIsClient(true);
    setData(props.data);
  }, [id]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (quickEditEnabled) {
      let mouseDownHandler = function(e) {
        const attributeNames = e.target.getAttributeNames();
        const tinaAttribute = attributeNames.find(
          (name) => name.startsWith("data-tina-field")
        );
        let fieldName;
        if (tinaAttribute) {
          e.preventDefault();
          e.stopPropagation();
          fieldName = e.target.getAttribute(tinaAttribute);
        } else {
          const ancestor = e.target.closest(
            "[data-tina-field], [data-tina-field-overlay]"
          );
          if (ancestor) {
            const attributeNames2 = ancestor.getAttributeNames();
            const tinaAttribute2 = attributeNames2.find(
              (name) => name.startsWith("data-tina-field")
            );
            if (tinaAttribute2) {
              e.preventDefault();
              e.stopPropagation();
              fieldName = ancestor.getAttribute(tinaAttribute2);
            }
          }
        }
        if (fieldName) {
          if (isInTinaIframe) {
            parent.postMessage(
              { type: "field:selected", fieldName },
              window.location.origin
            );
          }
        }
      };
      const style = document.createElement("style");
      style.type = "text/css";
      style.textContent = `
        [data-tina-field] {
          outline: 2px dashed rgba(34,150,254,0.5);
          transition: box-shadow ease-out 150ms;
        }
        [data-tina-field]:hover {
          box-shadow: inset 100vi 100vh rgba(34,150,254,0.3);
          outline: 2px solid rgba(34,150,254,1);
          cursor: pointer;
        }
        [data-tina-field-overlay] {
          outline: 2px dashed rgba(34,150,254,0.5);
          position: relative;
        }
        [data-tina-field-overlay]:hover {
          cursor: pointer;
          outline: 2px solid rgba(34,150,254,1);
        }
        [data-tina-field-overlay]::after {
          content: '';
          position: absolute;
          inset: 0;
          z-index: 20;
          transition: opacity ease-out 150ms;
          background-color: rgba(34,150,254,0.3);
          opacity: 0;
        }
        [data-tina-field-overlay]:hover::after {
          opacity: 1;
        }
      `;
      document.head.appendChild(style);
      document.body.classList.add("__tina-quick-editing-enabled");
      document.addEventListener("click", mouseDownHandler, true);
      return () => {
        document.removeEventListener("click", mouseDownHandler, true);
        document.body.classList.remove("__tina-quick-editing-enabled");
        style.remove();
      };
    }
  }, [quickEditEnabled, isInTinaIframe]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    parent.postMessage({ type: "open", ...props, id }, window.location.origin);
    window.addEventListener("message", (event) => {
      if (event.data.type === "quickEditEnabled") {
        setQuickEditEnabled(event.data.value);
      }
      if (event.data.id === id && event.data.type === "updateData") {
        setData(event.data.data);
        setIsInTinaIframe(true);
        const anyTinaField = document.querySelector("[data-tina-field]");
        if (anyTinaField) {
          parent.postMessage(
            { type: "quick-edit", value: true },
            window.location.origin
          );
        } else {
          parent.postMessage(
            { type: "quick-edit", value: false },
            window.location.origin
          );
        }
      }
    });
    return () => {
      parent.postMessage({ type: "close", id }, window.location.origin);
    };
  }, [id, setQuickEditEnabled]);
  return { data, isClient };
}
function useEditState() {
  const [edit, setEdit] = React.useState(false);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      parent.postMessage({ type: "isEditMode" }, window.location.origin);
      window.addEventListener("message", (event) => {
        var _a;
        if (((_a = event.data) == null ? void 0 : _a.type) === "tina:editMode") {
          setEdit(true);
        }
      });
    }
  }, []);
  return { edit };
}
const tinaField = (object, property, index) => {
  var _a, _b, _c;
  if (!object) {
    return "";
  }
  if (object._content_source) {
    if (!property) {
      return [
        (_a = object._content_source) == null ? void 0 : _a.queryId,
        object._content_source.path.join(".")
      ].join("---");
    }
    if (typeof index === "number") {
      return [
        (_b = object._content_source) == null ? void 0 : _b.queryId,
        [...object._content_source.path, property, index].join(".")
      ].join("---");
    }
    return [
      (_c = object._content_source) == null ? void 0 : _c.queryId,
      [...object._content_source.path, property].join(".")
    ].join("---");
  }
  return "";
};
const addMetadata = (id, object, path) => {
  Object.entries(object).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (isScalarOrUndefined(item)) {
          return;
        }
        if (Array.isArray(item)) {
          return;
        }
        const itemObject = item;
        addMetadata(id, itemObject, [...path, key, index]);
      });
    } else {
      if (isScalarOrUndefined(value)) {
        return;
      }
      const itemObject = value;
      addMetadata(id, itemObject, [...path, key]);
    }
  });
  if ((object == null ? void 0 : object.type) === "root") {
    return;
  }
  object._content_source = {
    queryId: id,
    path
  };
  return object;
};
function isScalarOrUndefined(value) {
  const type = typeof value;
  if (type === "string")
    return true;
  if (type === "number")
    return true;
  if (type === "boolean")
    return true;
  if (type === "undefined")
    return true;
  if (value == null)
    return true;
  if (value instanceof String)
    return true;
  if (value instanceof Number)
    return true;
  if (value instanceof Boolean)
    return true;
  return false;
}
const hashFromQuery = (input) => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char & 4294967295;
  }
  const nonNegativeHash = Math.abs(hash);
  const alphanumericHash = nonNegativeHash.toString(36);
  return alphanumericHash;
};



/***/ }),

/***/ 4626:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ TinaMarkdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const TinaMarkdown = ({
  content,
  components = {}
}) => {
  if (!content) {
    return null;
  }
  const nodes = Array.isArray(content) ? content : content.children;
  if (!nodes) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes.map((child, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MemoNode, { components, key: index, child });
  }));
};
const Leaf = (props) => {
  if (props.bold) {
    const { bold, ...rest } = props;
    if (props.components.bold) {
      const Component = props.components.bold;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.italic) {
    const { italic, ...rest } = props;
    if (props.components.italic) {
      const Component = props.components.italic;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("em", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.underline) {
    const { underline, ...rest } = props;
    if (props.components.underline) {
      const Component = props.components.underline;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("u", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.strikethrough) {
    const { strikethrough, ...rest } = props;
    if (props.components.strikethrough) {
      const Component = props.components.strikethrough;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("s", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.code) {
    const { code, ...rest } = props;
    if (props.components.code) {
      const Component = props.components.code;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.components.text) {
    const Component = props.components.text;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, props.text);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.text);
};
const MemoNode = (props) => {
  const MNode = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(
    () => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Node, { ...props }),
    [JSON.stringify(props)]
  );
  return MNode;
};
const Node = ({ components, child }) => {
  var _a, _b, _c, _d, _e, _f;
  const { children, ...props } = child;
  switch (child.type) {
    case "h1":
    case "h2":
    case "h3":
    case "h4":
    case "h5":
    case "h6":
    case "p":
    case "blockquote":
    case "ol":
    case "ul":
    case "li":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children }));
      }
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(child.type, {
        children: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children })
      });
    case "lic":
      if (components.lic) {
        const Component2 = components.lic;
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children }));
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: child.children }));
    case "img":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { src: child.url, alt: child.caption });
    case "a":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return (
          // @ts-ignore FIXME: TinaMarkdownContent needs to be a union of all possible node types
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children }))
        );
      }
      return (
        // @ts-ignore FIXME: TinaMarkdownContent needs to be a union of all possible node types
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", { href: child.url }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children }))
      );
    case "code_block":
      const value = child.value;
      if (components[child.type]) {
        const Component2 = components[child.type];
        return (
          // @ts-ignore FIXME: TinaMarkdownContent needs to be a union of all possible node types
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props })
        );
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, value));
    case "hr":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("hr", null);
    case "break":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null);
    case "text":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { components, ...child });
    case "mdxJsxTextElement":
    case "mdxJsxFlowElement":
      const Component = components[child.name];
      if (Component) {
        const props2 = child.props ? child.props : {};
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, { ...props2 });
      } else {
        if (child.name === "table") {
          const firstRowHeader = (_a = child.props) == null ? void 0 : _a.firstRowHeader;
          const rows = (firstRowHeader ? (_b = child.props) == null ? void 0 : _b.tableRows.filter((_, i) => i !== 0) : (_c = child.props) == null ? void 0 : _c.tableRows) || [];
          const header = (_e = (_d = child.props) == null ? void 0 : _d.tableRows) == null ? void 0 : _e.at(0);
          const TableComponent = components["table"] || ((props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("table", { ...props2 }));
          const TrComponent = components["tr"] || ((props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("tr", { ...props2 }));
          const ThComponent = components["th"] || ((props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("th", { style: { textAlign: (props2 == null ? void 0 : props2.align) || "auto" }, ...props2 }));
          const TdComponent = components["td"] || ((props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("td", { style: { textAlign: (props2 == null ? void 0 : props2.align) || "auto" }, ...props2 }));
          const align = ((_f = child.props) == null ? void 0 : _f.align) || [];
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TableComponent, null, firstRowHeader && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("thead", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TrComponent, null, header.tableCells.map((c, i) => {
            return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
              TinaMarkdown,
              {
                key: i,
                components: {
                  p: (props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ThComponent, { align: align[i], ...props2 })
                },
                content: c.value
              }
            );
          }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("tbody", null, rows.map((row, i) => {
            var _a2;
            return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TrComponent, { key: i }, (_a2 = row == null ? void 0 : row.tableCells) == null ? void 0 : _a2.map((c, i2) => {
              return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
                TinaMarkdown,
                {
                  key: i2,
                  components: {
                    p: (props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TdComponent, { align: align[i2], ...props2 })
                  },
                  content: c.value
                }
              );
            }));
          })));
        }
        const ComponentMissing = components["component_missing"];
        if (ComponentMissing) {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentMissing, { name: child.name });
        } else {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, `No component provided for ${child.name}`);
        }
      }
    case "maybe_mdx":
      return null;
    case "html":
    case "html_inline":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props });
      }
      return child.value;
    case "invalid_markdown":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, child.value);
    default:
      if (typeof child.text === "string") {
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { components, ...child });
      }
  }
};



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [94,487,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);